import { useMobileResponsive } from "@hooks/useDeviceType";
import IframeResizer from "iframe-resizer-react";

type DataGovEmbedCustomProps = {
  url: string;
};

export default function DataGovEmbedCustom({
  url,
}: DataGovEmbedCustomProps): React.ReactElement {
  const { isMobile, mounted } = useMobileResponsive();

  return (
    <div className="justify-center">
      <IframeResizer
        src={url}
        checkOrigin={false}
        heightCalculationMethod={mounted && isMobile ? "bodyScroll" : "max"}
        style={{
          width: "1px",
          minWidth: mounted && isMobile ? "95%" : "100%",
          border: "none",
          minHeight: mounted && isMobile ? "1040px" : "642px",
        }}
      />
    </div>
  );
}
